export interface IActivity {
    id: number;
    name: string;
    activeUntilDate?: Date;
}

const newActivity = (): IActivity => ({
    id: 0,
    name: '',
})

export const createActivity = <T extends Partial<IActivity>>(initialValues: T): IActivity & T => {
    return Object.assign(newActivity(), initialValues);
};